export default __webpack_public_path__ + "static/media/featured_player.0fc1d392.png";